import {createRouter,createWebHashHistory} from 'vue-router';
// import HomePage from '@/views/HomePage.vue';
import AirtelDepositWebsite from '@/views/mw/AirtelDepositWebsite.vue';
import TnmDepositWebsite from '@/views/mw/TnmDepositWebsite.vue';
import PaychanguMobileWebsite from '@/views/mw/PaychanguMobileWebsite.vue';
import PaychanguCreditCardWebsite from '@/views/mw/PaychanguCardDepositWebsite.vue';
import PaychanguBankTransferWebsite from '@/views/mw/PaychanguBankTranferDepositWebsite.vue';
import PaychanguBankTransferCallbackWebsite from '@/views/mw/PaychanguBankTransferCallbackWebsite.vue';
import DepositWebsiteMalawi from '@/views/DepositWebsiteMalawi.vue';
import NedbankDepositWebsite from '@/views/NedbankDepositWebsite.vue';
import NedbankDepositResponse from '@/views/NedbankDepositResponse.vue';
import VodacomDepositWebsite from '@/views/VodacomDepositWebsite.vue';
// import ExampleinlineCreditCardPaychangu from '@/views/ExampleinlineCreditCardPaychangu.vue';
import DepositWebsiteLesotho from '@/views/DepositWebsiteLesotho.vue';
import DepositMaintenanceLesotho from '@/views/DepositMaintenanceLesotho.vue';
import DepositMaintenanceMalawi from '@/views/DepositMaintenanceMalawi.vue';
import MywalletDepositWebsite from '@/views/ls/MywalletDepositWebsite.vue';
import OttvoucherDepositWebsite from '@/views/ls/OttvoucherDepositWebsite.vue';

import authMiddleware from '@/middleware/auth'; // Importa el middleware

// para rutas del newapp
import DepositAppLesotho from '@/views/newapp/DepositAppLesotho.vue';
import DepositAppMalawi from '@/views/newapp/DepositAppMalawi.vue';

const routes = [
  // { path: '/', name: 'LoginPage', component: LoginPage , title: 'Login' },
  { path: '/AirtelDepositWebsite', name: 'AirtelDepositWebsite', component: AirtelDepositWebsite , meta:{ title: 'Airtel Deposit Website'} },
  { path: '/TnmDepositWebsite', name: 'TnmDepositWebsite', component: TnmDepositWebsite , meta:{ title: 'Tnm Deposit Website'} },
  { path: '/PaychanguMobileWebsite', name: 'PaychanguMobileWebsite', component: PaychanguMobileWebsite , meta:{ title: 'Paychangu Mobile Deposit Website'} },
  { path: '/NedbankDepositWebsite', name: 'NedbankDepositWebsite', component: NedbankDepositWebsite , meta:{ title: 'Nedbank Deposit Website'} },
  { path: '/NedbankDepositResponse', name: 'NedbankDepositResponse', component: NedbankDepositResponse , meta:{ title: 'Nedbank Deposit Website'} },
  { path: '/VodacomDepositWebsite', name: 'VodacomDepositWebsite', component: VodacomDepositWebsite , meta:{ title: 'Vodacom Deposit Website'} },
  //{ path: '/ExampleinlineCreditCardPaychangu', name: 'ExampleinlineCreditCardPaychangu', component: ExampleinlineCreditCardPaychangu , meta:{ title: 'PayChangu Inline Checkout'} },
  { path: '/DepositWebsiteLesotho', name: 'DepositWebsiteLesotho', component: DepositWebsiteLesotho , meta:{ title: 'Deposit Website'} },
  { path: '/DepositWebsiteMalawi', name: 'DepositWebsiteMalawi', component: DepositWebsiteMalawi , meta:{ title: 'Deposit Website'} },
  { path: '/DepositMaintenanceLesotho', name: 'DepositMaintenanceLesotho', component: DepositMaintenanceLesotho , meta:{ title: 'Deposit Website'} },
  { path: '/DepositMaintenanceMalawi', name: 'DepositMaintenanceMalawi', component: DepositMaintenanceMalawi , meta:{ title: 'Deposit Website'} },
  { path: '/PaychanguCardWebsite', name: 'PaychanguCardWebsite', component: PaychanguCreditCardWebsite , meta:{ title: 'PayChangu Debit/Credit Card'} },
  { path: '/PaychanguBankTransferWebsite', name: 'PaychanguBankTransferWebsite', component: PaychanguBankTransferWebsite , meta:{ title: 'PayChangu Bank Transfer'} },
  { path: '/PaychanguBankTransferCallback', name: 'PaychanguBankTransferCallback', component: PaychanguBankTransferCallbackWebsite , meta:{ title: 'PayChangu Bank Transfer - Payment Confirmed'} },
  { path: '/MywalletDepositWebsite', name: 'MywalletDepositWebsite', component: MywalletDepositWebsite , meta:{ title: 'Mywallet Deposit Website'} },
  { path: '/OttvoucherDepositWebsite', name: 'OttvoucherDepositWebsite', component: OttvoucherDepositWebsite , meta:{ title: 'OTT Voucher Deposit Website'} },
  { path: '/DepositAppLesotho', name: 'DepositAppLesotho', component: DepositAppLesotho , meta:{ title: 'Deposit App Lesotho'} },
  { path: '/DepositAppMalawi', name: 'DepositAppMalawi', component: DepositAppMalawi , meta:{ title: 'Deposit App Malawi'} },
  // {path: '/Division', name:'DivisionPage', component: DivisionPage,meta: { requiresAuth: true , title: 'Division Page'} },
  // {
  //   path: '/main',
  //   component: MainLayout,
  //   children: [
  //       { path: '', name: 'HomePage', component: HomePage  },
  //       { path: 'user', name: 'UserView', component: UserView  , meta: { requiresAuth: true } },
  //       { path: 'csv', name: 'CsvPage', component: CsvPage  , meta: { requiresAuth: true } },
  //       { path: 'singleDepositPage', name: 'SingleDepositPage', component: SingleDepositPage , meta: { requiresAuth: true , title: 'Single Deposit' }},
  //       { path: 'rollPage', name: 'RollBasePage', component: RollBasePage , meta: { requiresAuth: true } },
  //       { path: 'DepWithPage', name: 'DepWithPage', component: DepWithPage , meta: { requiresAuth: true , title: 'Deposit' }},
  //       { path: 'WithdrawPage', name: 'WithdrawPage', component: WithdrawPage , meta: { requiresAuth: true } },
  //       { path: 'AutomaticDepositPage', name: 'AutomaticDepositPage', component: AutomaticDepositPage , meta: { requiresAuth: true }  },
  //       {path: 'ReqDepositePage',name: 'ReqDepositePage',component: ReqDepositePage,meta: { requiresAuth: true } },
  //     ],
  //   meta: { requiresAuth: true }
  // }
];

const router = createRouter({
    history : createWebHashHistory(),
    routes
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "WSB Financial System";
  //console.log('Antes de llamar al middleware'); // Depuración inicial
  authMiddleware(to, from, next); // Llama al middleware
  //console.log('Después de llamar al middleware'); // Depuración final
});

export default router;